// import { createTheme } from '@mui/material/styles';

// import breakpoints from 'utils/breakpoints';
// import { getColor } from 'utils/colors';
// import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// 	mixins: mixins,
// });

export const styles = {};

export const overrides = {
	'.BeachFlagChart-root': {
		display: 'flex',
		flexDirection: 'column',
		gap: remCalc(64),

		'.BeachFlagChart-headerContainer': {
			'>div': {
				justifySelf: 'center',
			}
		},
		'.BeachFlagChart-header': {
			textTransform: 'uppercase',
		},

		'.BeachFlagChart-row': {
			'.BeachFlagChart-flagName': {
				fontWeight: 400,
				textTransform: 'uppercase',
			},

			'>div': {
				justifySelf: 'center',
				textAlign: 'center',
			},
		},
	},
};

export default styles;